import axios from "axios";
import { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { Table, Typography } from "antd";
import ParticularCandidates from "../onboarding/particularcandidates/ParticularCandidates";
const { Text } = Typography;

export default function HrVerifiedCandidates() {
    const { authData, backUrl } = useContext(AuthContext);
    const [candidates, setCandidates] = useState([]);
    const [showParticular, setShowParticular] = useState({
        show: false,
        cid: 0,
    });

    const fetchCandidates = async () => {
        try {
            const res = await axios.get(
                `${backUrl}/api/emp/payrollhr-review-list/`,
                { headers: { Authorization: `Bearer ${authData?.access}` } }
            );
            setCandidates(res.data.results || res.data);
            console.log(res.data)
        } catch (err) {
            console.error("Error fetching verified candidates:", err);
        }
    };

    useEffect(() => {
        fetchCandidates();
    }, []);

    const columns = [
        {
            title: "Candidate Name",
            dataIndex: "first_name",
            key: "first_name",
            render: (text, record) => {
                if (!text && !record.last_name) return "-";

                const initial = text ? text.charAt(0).toUpperCase() : "";
                const firstName = text || "";
                const lastName = record.last_name || "";

                return (
                    <a
                        style={{ color: "#0e497b", cursor: "pointer" }}
                        onClick={() => setShowParticular({ show: true, cid: record.candidate })}
                    >
                        {initial}. {firstName} {lastName}
                    </a>
                );
            },
        },
        {
            title: <Text style={{ color: "#ffffff" }}>Organisation</Text>,
            dataIndex: "requisition_organisation",
            key: "",
        },
        {
            title: <Text style={{ color: "#ffffff" }}>Department</Text>,
            dataIndex: "requisition_department",
            key: "",
        },
        {
            title: <Text style={{ color: "#ffffff" }}>Designation</Text>,
            dataIndex: "requisition_designation",
            key: "",
        },
        {
            title: <Text style={{ color: "#ffffff" }}>Mobile No</Text>,
            dataIndex: "mobile_number",
            key: "mobile_number",
        },
        {
            title: <Text style={{ color: "#ffffff" }}>Mail</Text>,
            dataIndex: "email_id",
            key: "email_id",
        },
        {
            title: <Text style={{ color: "#ffffff" }}>Gender</Text>,
            dataIndex: "gender",
            key: "gender",
        },
        {
            title: <Text style={{ color: "#ffffff" }}>DOB</Text>,
            dataIndex: "date_of_birth",
            key: "date_of_birth",
        },
    ];

    // Filter out empty names if needed
    const dataSource = candidates.filter(
        (c) => c.first_name && c.first_name !== ""
    );

    return (
        <>
            {showParticular.show ? (
                <>
                    <div className="d-flex justify-content-between">
                        <div id="bread-container">
                            <a
                                className="bread-anchor"
                                id="bread-acr"
                                style={{ cursor: "pointer" }}
                                onClick={() => setShowParticular({ show: false, cid: 0 })}
                            >
                                {showParticular.show ? "← Back" : "Verified Candidates"}
                            </a>
                        </div>
                    </div>
                    <ParticularCandidates cid={showParticular.cid} />
                </>
            ) : (
                <>
                    <div className="table-responsive mt-3">
                        <Table
                            columns={columns}
                            dataSource={dataSource.length > 0 ? dataSource : []}
                            rowKey={(record) => record.id}
                            bordered
                            pagination={false}
                            scroll={{ x: "max-content" }}
                            locale={{
                                emptyText: (
                                    <Text type="secondary">No verified candidates found.</Text>
                                ),
                            }}
                            style={{
                                marginTop: 16,
                                border: "1px solid #d9d9d9",
                            }}
                            components={{
                                header: {
                                    cell: (props) => (
                                        <th
                                            {...props}
                                            style={{ backgroundColor: "#0e497b", color: "#fff" }}
                                        />
                                    ),
                                },
                            }}
                        />
                    </div>
                </>
            )}
        </>
    );
}
